// Import global components
import AoCheckboxesCollapse from '@/components/ui/AoCheckboxesCollapse.vue'
import AoTimePicker from '@/components/ui/AoTimePicker.vue'
import AoDragNDropList from '@/components/ui/AoDragNDropList.vue'
import AoDragNDropListItem from '@/components/ui/AoDragNDropListItem.vue'
import AoCheckboxesCollapseList from '@/components/ui/AoCheckboxesCollapseList.vue'
import AoDragNDropCollapse from '@/components/ui/AoDragNDropCollapse.vue'

import AoTabs from '@/components/ui/AoTabs.vue'
import AoRatings from '@/components/ui/AoRatings.vue'
import AoSelectGroup from '@/components/ui/AoSelectGroup.vue'
import AoTags from '@/components/ui/AoTags.vue'
import AoWidget from '@/components/ui/AoWidget.vue'
import AoFileInputAvatar from '@/components/ui/AoFileInputAvatar.vue'
import AoJsonViewer from '@/components/ui/AoJsonViewer.vue'
import AoCollapse from '@/components/ui/AoCollapse.vue'
import VChart from 'vue-echarts'
import ModuleInDevelopment from '@/components/base/ModuleInDevelopment.vue'
import AoSimpleEntityItem from '@/components/ui/AoSimpleEntityItem.vue'
import AoChips from '@/components/ui/AoChips.vue'
import AoGroupedList from '@/components/ui/AoGroupedList.vue'
import AoPhoneInput from '@/components/ui/AoPhoneInput.vue'
import AoTabLinks from '@/components/ui/AoTabLinks.vue'

// Forms
import FormsWrapper from '@/components/ui/forms/FormsWrapper.vue'
import FormsMicroform from '@/components/ui/forms/FormsMicroform.vue'
import FormsMicroformEmployees from '@/components/ui/forms/FormsMicroformEmployees.vue'
import FormsFooter from '@/components/ui/forms/FormsFooter.vue'
import FormsSimpleEntityItemList from '@/components/ui/forms/FormsSimpleEntityItemList.vue'
import FormFooter from '@/components/ui/forms/FormFooter.vue'

// Passport
import PassportList from '@/components/ui/passport/PassportList.vue'
import PassportTabs from '@/components/ui/passport/PassportTabs.vue'
import PassportTable from '@/components/ui/passport/PassportTable.vue'
import PassportInfoCard from '@/components/ui/passport/PassportInfoCard.vue'
import PassportInfoBlock from '@/components/ui/passport/PassportInfoBlock.vue'
import PassportCollapse from '@/components/ui/passport/PassportCollapse.vue'
import PassportWidget from '@/components/ui/passport/PassportWidget.vue'
import PassportLimitProgressBar from '@/components/ui/passport/PassportLimitProgressBar.vue'

import { VueTelInput } from 'vue-tel-input'
import 'vue-tel-input/vue-tel-input.css'
const globalPhoneInputOptions = {
	mode: 'international',
}

export function registerOntrackComponents(app) {
	app
		.component(AoCheckboxesCollapse.name, AoCheckboxesCollapse)
		.component('ao-phone-input', AoPhoneInput)
		.component(AoTimePicker.name, AoTimePicker)
		.component(AoDragNDropList.name, AoDragNDropList)
		.component(AoDragNDropListItem.name, AoDragNDropListItem)
		.component(AoCheckboxesCollapseList.name, AoCheckboxesCollapseList)
		.component(AoDragNDropCollapse.name, AoDragNDropCollapse)
		.component(AoJsonViewer.name, AoJsonViewer)
		.component(AoTabs.name, AoTabs)
		.component(AoRatings.name, AoRatings)
		.component(AoSelectGroup.name, AoSelectGroup)
		.component(AoTags.name, AoTags)
		.component(AoWidget.name, AoWidget)
		.component(AoFileInputAvatar.name, AoFileInputAvatar)
		.component(AoCollapse.name, AoCollapse)
		.component('ao-simple-entity-item', AoSimpleEntityItem)
		.component('ao-chips', AoChips)
		.component(AoGroupedList.name, AoGroupedList)
		.component('ao-tab-links', AoTabLinks)
		.component(FormsWrapper.name, FormsWrapper )
		.component(FormsMicroform.name, FormsMicroform  )
		.component(FormsMicroformEmployees.name, FormsMicroformEmployees  )
		.component('FormsSimpleEntityItemList', FormsSimpleEntityItemList  )
		.component(FormsFooter.name, FormsFooter  )
		.component(FormFooter.name, FormFooter  )
		.component(PassportList.name, PassportList)
		.component(PassportTabs.name, PassportTabs)
		.component(PassportTable.name, PassportTable)
		.component(PassportInfoCard.name, PassportInfoCard)
		.component(PassportInfoBlock.name, PassportInfoBlock)
		.component(PassportCollapse.name, PassportCollapse)
		.component(PassportWidget.name, PassportWidget)
		.component(PassportLimitProgressBar.name, PassportLimitProgressBar)
		.component('AoChart', VChart)
		.component(ModuleInDevelopment.name, ModuleInDevelopment)

	app.use(VueTelInput, globalPhoneInputOptions)
}
